module.exports = __webpack_public_path__ + "static/media/activity.328cea88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/icons/activity.svg
// module id = 329
// module chunks = 0